/* eslint-disable complexity */
// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { useIntl } from "react-intl";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { PatternLogos } from "@/patterns/wpl/logos/src";

const inlineLogosProp = [
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:b12e4075-84f4-467e-9acf-f062c8fdaece/twilio-n50.svg",
        alt: "Twilio",
        width: "107px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:35c6a74c-a259-4dac-8df8-ea8c5b12f44d/nasa-n50.svg",
        alt: "Nasa",
        width: "71px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:5a1e47e3-be98-4279-a3a2-c626164dbd5d/illumina-n50.svg",
        alt: "Illumina",
        width: "100px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:54c6035e-1055-4d48-8173-4f41b5d46263/linkedin-n50.svg",
        alt: "LinkedIn",
        width: "101px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:731482d9-54c4-48e7-a10b-ab601ca4fbd6/docker-n50.svg",
        alt: "Docker",
        width: "126px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:7343b372-8a2a-4156-8755-bcf38735ca6b/morningstar-n50.svg?cdnVersion=1278",
        alt: "Morning Star",
        width: "134px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:c67f93d6-d8be-4970-b4f5-addf24c13e4e/rtr-n50.svg",
        alt: "RTR",
        width: "43.71px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:b62031f5-0770-46cb-a1c2-50cdacb8a0b0/anz-n50.svg",
        alt: "ANZ",
        width: "102px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:475f41d8-45f4-48c9-a9b2-d78215ae4b16/nyt-n50.svg",
        alt: "New York Times",
        width: "223px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:6841df63-0c84-4075-9ac5-1ed0f8ddea17/gopro-n50.svg",
        alt: "GoPro",
        width: "110px"
    }
];

const patternLogosConfluencePageStyle = css`
    ${media.above.xxs} {
        padding: 0 0 ${token("space.400")};
    }

    .text-section {
        padding-top: 48px;

        h2 {
            color: #253858;
            margin-top: 0;
            letter-spacing: 0.3px;
            padding: 0 16px;

            ${media.above.sm} {
                font-size: 1.5rem;
                line-height: 1.333;
            }

            ${UNSAFE_media.below.sm} {
                font-size: 1.25rem;
                line-height: 1.2;
            }
        }
    }

    .row-layout {
        width: 100%;
        padding: 0;

        .logos-content {
            display: flex;
            flex-wrap: wrap;
            gap: 0;
            align-items: center;
            justify-content: center;
            max-width: 1000px;
            margin: auto;
            padding: 16px 0;

            // hardcoding max-width here to prevent single "orphans" wrapping to their own line
            @media (min-width: 850px) and (max-width: 1170px) {
                max-width: 820px;
                margin: 0 auto;
            }
            @media (max-width: 665px) {
                max-width: 490px;
                margin: 0 auto;
            }

            .logoblock {
                margin: 16px 32px;
                + img {
                    margin-bottom: ${token("space.200")};
                    vertical-align: bottom;
                    point-events: none;
                    max-width: 100%;
                }
            }
        }
    }

    .row-layout:last-child {
        margin-top: ${token("space.0")};
    }
`;

const SocialProof = () => {
    const intl = useIntl();
    const patternLogoBodyText = intl.formatMessage({
        id: "ConfluenceSoftwarePageTemplate.socialProof.bodyText",
        defaultMessage:
            "75,000+ customers rely on Confluence to drive progress that counts"
    });

    return (
        <div>
            <PatternLogos
                css={patternLogosConfluencePageStyle}
                inlineLogos={inlineLogosProp}
                headerText={patternLogoBodyText}
            />
        </div>
    );
};

export default SocialProof;
